const dmsRouter = [{
  path: '/dms',
  component: () => import('@/pages/dms/Index'),
  redirect: {
    name: 'createtable'
  },
  children: [{
    name: 'dmsdatabase',
    path: 'database',
    meta: {
      title: 'Database Management'
    },
    component: () => import('@/pages/dms/DatabaseManagement'),
  }, {
    name: 'massactions',
    path: 'actions',
    meta: {
      title: 'Table Mass Actions'
    },
    component: () => import('@/pages/dms/TableMassActions'),
  }, {
    name: 'tabledetail',
    path: 'actions/detail',
    meta: {
      title: 'Table Mass Actions'
    },
    component: () => import('@/pages/dms/TableDetail'),
  }, {
    name: 'statistics',
    path: 'statistics',
    meta: {
      title: 'Table Data Statistics'
    },
    component: () => import('@/pages/dms/TableDataStatistics'),
  }, {
    name: 'dmssql',
    path: 'sql',
    meta: {
      title: 'SQL Window'
    },
    component: () => import('@/pages/dms/SqlWindow'),
  }, {
    name: 'command',
    path: 'command',
    meta: {
      title: 'Command Window'
    },
    component: () => import('@/pages/dms/CommandWindow'),
  }, {
    name: 'createtable',
    path: 'createtable',
    meta: {
      title: 'Table'
    },
    component: () => import('@/pages/dms/CreateTable'),
  }, ]
}]
export default dmsRouter



// WEBPACK FOOTER //
// ./src/router/modules/dms.js